import React, {useEffect, useState} from "react";
import "./WorkExperience.scss";
import {workExperiences} from "../../portfolio";
import {Fade} from "react-reveal";

export default function WorkExperience() {
  const [activeIndex, setActiveIndex] = useState(0);
  const experiences = workExperiences.experience;

  useEffect(() => {
    const orbitTimer = setInterval(() => {
      setActiveIndex(index => (index + 1) % experiences.length);
    }, 6500);
    return () => clearInterval(orbitTimer);
  }, [experiences.length]);

  if (!workExperiences.display) return null;

  const changeSlide = direction => {
    setActiveIndex(
      index => (index + direction + experiences.length) % experiences.length
    );
  };

  const slidePosition = index => {
    let offset = index - activeIndex;
    if (offset > experiences.length / 2) offset -= experiences.length;
    if (offset < -experiences.length / 2) offset += experiences.length;
    if (offset === 0) return "is-active";
    if (offset === -1) return "is-previous";
    if (offset === 1) return "is-next";
    return "is-hidden";
  };

  return (
    <section className="experience-container" id="experience">
      <Fade bottom duration={900} distance="20px">
        <div className="experience-header">
          <div>
            <p className="section-kicker">FLIGHT LOG / CAREER TRAJECTORY</p>
            <h1 className="experience-heading">Work Experience</h1>
          </div>
          <div className="carousel-controls">
            <button onClick={() => changeSlide(-1)} aria-label="Previous experience">←</button>
            <span>{String(activeIndex + 1).padStart(2, "0")} / {String(experiences.length).padStart(2, "0")}</span>
            <button onClick={() => changeSlide(1)} aria-label="Next experience">→</button>
          </div>
        </div>
      </Fade>

      <div className="experience-carousel">
        <div className="carousel-orbit" />
        {experiences.map((card, index) => (
          <article
            className={`experience-slide ${slidePosition(index)}`}
            key={`${card.company}-${card.date}`}
            aria-hidden={index !== activeIndex}
          >
            <span className="mission-number">MISSION {String(index + 1).padStart(2, "0")}</span>
            <div className="experience-logo-wrap">
              {card.companylogo ? (
                <img src={card.companylogo} alt="" />
              ) : (
                <span className="experience-company-mark">{card.companyMark}</span>
              )}
            </div>
            <div className="experience-slide-content">
              <p className="experience-company">{card.company}</p>
              <h2>{card.role}</h2>
              <p className="experience-date">{card.date}</p>
              <p className="experience-description">{card.desc}</p>
            </div>
          </article>
        ))}
      </div>

      <div className="carousel-dots" aria-label="Choose an experience">
        {experiences.map((card, index) => (
          <button
            key={card.company + index}
            className={index === activeIndex ? "is-active" : ""}
            onClick={() => setActiveIndex(index)}
            aria-label={`Show ${card.company}`}
          />
        ))}
      </div>
    </section>
  );
}
